module.exports = __webpack_public_path__ + "img/mark-view-icon.4c582539.svg";